import ConnectableObject from "./ConnectableObject";
import { copyAllProperties } from "./utils";
import Connection from "./Connection";
import { ConnectionType } from "./Connection";
import {
  ChannelType,
  channelTypeFromString,
  channelTypeHirarchie,
  channelTypeInfo,
  isSameLightRolloHeating,
} from "./ChannelType";
import BaseModel from "./BaseModel";
import BaseObject from "./BaseObject";
import Consumer from "./Consumer";
import BaseModelMap from "./BaseModelMap";
import type Page from "./Page";

//////////////////////////////////////////////////
import ObjectFactory from "./ObjectFactory";
import Logger from "../Logger";
import ButtonChannel from "./ButtonChannel";
import Scene from "./Scene";
import SignalType from "./SignalType";
import GroupAddress from "./GroupAdress";
import Signal from "./Signal";
import type Channel from "./Channel";

const logger = new Logger();
ObjectFactory.registerClass("Multiplexer", (data?: any, parent?: BaseModel) => {
  return new Multiplexer(data, parent);
});
//////////////////////////////////////////////////
export default class Multiplexer extends Scene {
  public get className(): string {
    return "Multiplexer"; // no itx
  }

  getParentCollectionName(): string | undefined {
    return "multiplexers"; // no itx
  }

  // persistent properties

  public get isScene(): boolean {
    return false;
  }
  public get isMultiplexer(): boolean {
    return true;
  }

  //////////////////////////////
  delete(): Array<BaseObject> {
    this.isDeleting = true;

    const res = this.signals.deleteAllItems();

    return [...res, ...super.delete()];
  }

  getChannelType(): ChannelType {
    if (this._channelType == ChannelType.Unknown) {
      this._channelType = ChannelType.Generic;
    }
    return this._channelType; // allow return defined channeltype, if not defined default channeltype generic
  }

  getChangableChannelType(): Array<string> {
    const res = new Array<string>();
    for (const i in ChannelType) {
      if (channelTypeInfo(channelTypeFromString(i)).isLight) {
        res.push(i);
      } else if (channelTypeInfo(channelTypeFromString(i)).isRollo) {
        res.push(i);
      }
    }

    return res;
  }
  // multiplexer uses Tags Scenes not
  getFullTagParts(): Array<any> {
    return this.baseObjectGetFullTagParts();
  }

  getIconUrl(): string | undefined {
    return "/images/various/multiplexer.png"; // no itx
  }

  constructor(data?: any, parent?: BaseModel) {
    super(data, parent);

    copyAllProperties(data, this);
    this.connections.onChange.subscribe((changedObject: BaseObject, changedProperty: string | any | undefined) => {
      logger.log("scene connected or disconnected");
    });
  }

  signals = new BaseModelMap<Signal>(Signal, this, "s");

  //////////////////////////////

  getPersistentProperties(): string[] {
    return ["signals", ...super.getPersistentProperties()]; // no itx
  }

  getParentChildrenGroup(): Array<BaseModel> | undefined {
    return state.sceneGroup.asArray();
  }

  // parentSceneGroup: SceneGroup | null = null;

  isConnectable(type: ConnectionType, partnerObject: ConnectableObject, checkForConnection?: Connection) {
    if (type == ConnectionType.Channel || channelTypeInfo(partnerObject.channelType).isSupply) {
      return false;
    }

    if (partnerObject.className == "Button" || partnerObject.className == "ButtonChannel") {
      if (this.channelType == ChannelType.Generic) {
        return true;
      }
      return isSameLightRolloHeating(partnerObject.channelType, this.channelType) != undefined;
    }

    if (partnerObject.className == "Scene") {
      return false;
    }

    if (partnerObject.className == "Consumer") {
      if (this.channelType == ChannelType.Generic) {
        return !channelTypeInfo(partnerObject.channelType).isSupply;
      } else {
        if (isSameLightRolloHeating(this.channelType, partnerObject.channelType)) {
          return true;
        }
      }
    }

    return false;
  }

  getConnectedConsumers(): Array<Consumer> {
    var res = new Array<Consumer>();
    logger.log(`getConnectedConsumers ${this.connections.size}`);
    this.connections.forEach((connection) => {
      const p = connection.getPartner(this);
      if (p?.className == "Consumer") {
        res.push(p as Consumer);
      }
    });
    return res;
  }

  //////////////////////////////////////////////////////////////////
  connect(page: Page, obj: Consumer | ButtonChannel) {
    var multiplexer = this;
    const c = new Connection({}, page);

    c.type = ConnectionType.Button;

    /// from = consumer
    c.fromId = obj.id;

    /// to = channel
    c.toId = multiplexer.id;

    c.addToConnectableObjects();
    c.addToPage();

    /// change channel Type if hirarchic under
    this.changeChangableChannelType(obj);

    multiplexer.parent?.raiseOnChange(); // to update drawing in compact view

    // allow redraw, to get correct port position in collapsed mode
    setTimeout(() => {
      c.updateEndPoints();
    }, 100);
  }
  changeChangableChannelType(obj: ConnectableObject) {
    let hirararchie: Array<ChannelType> | undefined;
    if (obj.className == "Consumer") {
      if (channelTypeInfo(obj.channelType).isLight) {
        hirararchie = channelTypeHirarchie("isLight"); // no itx
      } else if (channelTypeInfo(obj.channelType).isRollo) {
        hirararchie = channelTypeHirarchie("isRollo"); // no itx
      }

      if (hirararchie) {
        const indexOfThisChanneltype = hirararchie.indexOf(this.channelType);
        const indexOfConsumerChannelType = hirararchie.indexOf(obj.channelType);
        if (indexOfThisChanneltype > indexOfConsumerChannelType) {
          this.channelType = obj.channelType;
          this.raiseOnChange("channelType");
        }
      }
    }
    if (obj.className == "ButtonChannel") {
      if (obj.channelType == ChannelType.Generic && this.channelType == ChannelType.Generic) {
        this.channelType = ChannelType.Switch;
        obj.channelType = ChannelType.Switch;
      }
    }
  }

  //////////////////////////////////////////////////////
  ///////////// for paste

  getGroupAddressByType(type: SignalType) {
    var res: GroupAddress | undefined;
    this.signals.forEach((signal) => {
      if (signal.type == type) {
        res = signal.groupAddresses.asArray()[0];
      }
    });
    return res;
  }

  getAllMultiplexerNamesWithoutOwn(): string[] | undefined {
    const sceneNames = new Array<string>();
    state.sceneGroup.forEach((scene) => {
      if (scene.className == "Multiplexer" && scene != this) {
        sceneNames.push(scene.name);
      }
    });
    return sceneNames;
  }

  getAllTagsFromSameTypeWithoutOwn(): string[] | undefined {
    const multiplexerTags = new Array<string>();
    state.sceneGroup.forEach((scene) => {
      if (scene.className == "Multiplexer" && scene != this) {
        multiplexerTags.push(scene.tag);
      }
    });
    return multiplexerTags;
  }

  getAllConnectedButtonChannels(): Array<ButtonChannel> {
    const res = new Array<ButtonChannel>();

    this.connections.forEach((connection) => {
      const partner = connection.getPartner(this);
      if (partner?.className == "ButtonChannel") {
        res.push(partner as ButtonChannel);
      }
    });

    return res;
  }

  getAllConnectedConsumers(): Array<Consumer> {
    const res = new Array<Consumer>();

    this.connections.forEach((connection) => {
      const partner = connection.getPartner(this);
      if (partner?.className == "Consumer") {
        res.push(partner as Consumer);
      }
    });

    return res;
  }

  connectWith(page: Page, consumer: Consumer | ButtonChannel | Channel): Connection {
    let connectionType = ConnectionType.Button;

    if (consumer.isButtonChannel) {
      connectionType = ConnectionType.Button;
    } else if (consumer.isConsumer) {
      connectionType = ConnectionType.Button;
    } else if (consumer.isChannel) {
      connectionType = ConnectionType.Channel;
    }

    return this.connectObject(page, consumer, connectionType);
  }

  // Copy from Consumer
  getOrCreateSignalByType(type: SignalType): Signal | undefined {
    return Consumer.getOrCreateSignalByType(this, type);
  }

  getSignalByType(type: SignalType): Signal | undefined {
    return Consumer.getSignalByType(this, type);
  }
}
